<path
    d="M24.9989 45.8335C36.5048 45.8335 45.8322 36.5061 45.8322 25.0001C45.8322 13.4942 36.5048 4.16681 24.9989 4.16681C13.4929 4.16681 4.16553 13.4942 4.16553 25.0001C4.16553 36.5061 13.4929 45.8335 24.9989 45.8335Z"
    stroke="currentColor"
    stroke-width="4.16667"
    stroke-linecap="round"
    stroke-linejoin="round"
    fill="#31363b05"
/>
<path
    d="M25 16.6668V25.0001"
    stroke="currentColor"
    stroke-width="4.16667"
    stroke-linecap="round"
    stroke-linejoin="round"
/>
<path
    d="M25 33.3332H25.0193"
    stroke="currentColor"
    stroke-width="4.16667"
    stroke-linecap="round"
    stroke-linejoin="round"
/>
